<mat-card [class]="customCardClass() + ' p-4'">
  <div class="mb-3 flex flex-wrap items-start justify-between gap-3">
    <div class="min-w-0 flex-1">
      <div class="grid grid-flow-col auto-cols-auto justify-between items-center">
        <div class="text-xl font-semibold">{{ title() }}</div>
        @if (showActionButton()) {
          <ng-content />
        <div>
          <button matIconButton type="button" (click)="doTableAction(tableActionData())">
            <mat-icon>{{ actionIcon() }}</mat-icon>
          </button>
        </div>
      }
      </div>
      @if (subtitle()) {
        <p class="mt-1 text-sm">{{ subtitle() }}</p>
      }

      @if (searchEnabled()) {
        <div class="mt-2 flex max-w-md items-center gap-2">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ searchLabel() }}</mat-label>
            <input
              #searchInput
              matInput
              [value]="searchTerm()"
              (keyup.enter)="applySearch(searchInput.value)"
              [placeholder]="searchPlaceholder()" />
            <button
              mat-icon-button
              matSuffix
              type="button"
              (click)="applySearch(searchInput.value)"
              [disabled]="loading()"
              [attr.aria-label]="searchLabel()"
              matTooltip="Search"
            >
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>
      }

      <ng-content select="[tableFilters]" />
    </div>

    @if (showRefresh()) {
      <!-- <button mat-stroked-button type="button" (click)="refreshed.emit()" [disabled]="loading()">Refresh</button> -->
      <button matButton="filled" type="button" (click)="refreshed.emit()">
        <mat-icon>refresh</mat-icon>
        Refresh
      </button>
    }
  </div>

  @if (loading() && rows().length === 0) {
    <div class="flex items-center gap-3 p-4">
      <mat-spinner diameter="24" />
      {{ loadingMessage() }}
    </div>
  } @else {
    @if (loading()) {
      <mat-progress-bar mode="indeterminate" class="mb-8" />
    }

    <div class="overflow-x-auto">
      <table mat-table [dataSource]="rows()" class="min-w-full">
        @for (column of columns(); track trackByColumnId($index, column)) {
          <ng-container [matColumnDef]="column.id">
            <th mat-header-cell *matHeaderCellDef [ngClass]="(column.headerClass ?? '') + ($index === 0 ? ' rounded-tl-xl' : '') + ($index === columns().length - 1 && !actionsTemplate() ? ' rounded-tr-xl' : '')" >{{ column.header }}</th>
            <td mat-cell *matCellDef="let row" [ngClass]="column.cellClass ?? ''">{{ resolveCellValue(column, row) }}</td>
          </ng-container>
        }

        @if (actionsTemplate(); as rowActionsTemplate) {
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="!text-right !pr-9 rounded-tr-xl">Actions</th>
            <td mat-cell *matCellDef="let row">
              <div class="flex justify-end gap-2">
                <ng-container [ngTemplateOutlet]="rowActionsTemplate" [ngTemplateOutletContext]="{ $implicit: row }" />
              </div>
            </td>
          </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="displayedColumns()" class="!bg-(--pg-brand-blue) !text-(--pg-text-light)"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>

        <tr class="mat-mdc-no-data-row" *matNoDataRow>
          <td class="mat-mdc-cell p-4 text-sm" [attr.colspan]="displayedColumns().length">{{ emptyMessage() }}</td>
        </tr>
      </table>
    </div>

    @if (paginationEnabled() && rows().length > 0) {
      <mat-paginator
        class="mt-3"
        [length]="totalCount()"
        [pageIndex]="pageNumber() - 1"
        [pageSize]="pageSize()"
        [pageSizeOptions]="pageSizeOptions()"
        [hidePageSize]="!showPageSizeOptions()"
        [disabled]="loading()"
        showFirstLastButtons
        (page)="onPage($event)" />
    }
  }
</mat-card>